// Copyright (c) 2016 Deere & Company

import * as busyCounter from '../../../shared/action-creators/busy-counter';
import {
    getOtherUseAmountUnits,
    getRegistrationTypes
} from '../../../product/shared/repositories';
import actions from '../../actions-list';
import {readProductDetails} from './product-details';
import {readRegistration} from './registration';

export const updateDomainValues = (property, pin, registrationId) =>

    async dispatch => {

        dispatch(busyCounter.increaseBusyCounter());

        try {

            const map = {
                otherUseUnits: getOtherUseAmountUnits,
                registrationTypes: getRegistrationTypes
            };

            const data = await map[property]();

            dispatch({
                data,
                property,
                type: actions.UPDATE_NEW_REGISTRATION_DOMAIN_VALUES
            });

            if (pin) {

                readProductDetails(pin, true, data)(dispatch);

            }

            if (registrationId) {

                readRegistration(registrationId)(dispatch);

            }

        } catch (error) {

            throw error;

        } finally {

            dispatch(busyCounter.decreaseBusyCounter());

        }

    };



// WEBPACK FOOTER //
// ./src/product/product-registration/action-creators/registration-domain-values.js